const CLAIM_BREWERY_HANDOFF_STORAGE_KEY = 'itt-claim-brewery-id';

let takenBreweryId = '';
let takeIsOpen = false;
let takeTicket = 0;

function sessionStore() {
  if (typeof window === 'undefined' || !window.sessionStorage) {
    return null;
  }
  return window.sessionStorage;
}

function rememberStoredId(breweryId) {
  const storage = sessionStore();
  if (!storage) {
    return false;
  }
  try {
    storage.setItem(CLAIM_BREWERY_HANDOFF_STORAGE_KEY, breweryId);
    return true;
  } catch {
    return false;
  }
}

function readStoredId() {
  const storage = sessionStore();
  if (!storage) {
    return '';
  }
  try {
    const stored = storage.getItem(CLAIM_BREWERY_HANDOFF_STORAGE_KEY);
    return typeof stored === 'string' ? stored.trim() : '';
  } catch {
    return '';
  }
}

function removeStoredId() {
  const storage = sessionStore();
  if (!storage) {
    return;
  }
  try {
    storage.removeItem(CLAIM_BREWERY_HANDOFF_STORAGE_KEY);
  } catch {
    // Ignore storage failures. The in-memory take still consumes the id.
  }
}

/**
 * @param {string} search
 * @returns {string}
 */
export function readBreweryIdQueryParam(search) {
  const query = typeof search === 'string' ? search : '';
  const normalized = query.startsWith('?') ? query.slice(1) : query;
  const params = new URLSearchParams(normalized);
  const breweryId = params.get('breweryId');
  if (typeof breweryId !== 'string') {
    return '';
  }
  return breweryId.trim();
}

/**
 * Remembers the brewery id from the app login link. Blank values are ignored.
 * @param {string} breweryId
 */
export function storeClaimBreweryHandoff(breweryId) {
  const trimmed = typeof breweryId === 'string' ? breweryId.trim() : '';
  if (!trimmed) {
    return;
  }
  if (!rememberStoredId(trimmed)) {
    return;
  }
  takeTicket += 1;
  takeIsOpen = false;
  takenBreweryId = '';
}

/**
 * Reads the stored id without consuming it.
 * @returns {string}
 */
export function peekClaimBreweryHandoff() {
  if (takeIsOpen) {
    return takenBreweryId;
  }
  return readStoredId();
}

/**
 * Reads the stored id once and removes it from sessionStorage.
 * A second call while the take is still open returns the same id so a
 * strict-mode remount can finish the same attempt.
 * @returns {{ breweryId: string, ticket: number }}
 */
export function takeClaimBreweryHandoff() {
  if (takeIsOpen) {
    takeTicket += 1;
    return { breweryId: takenBreweryId, ticket: takeTicket };
  }
  const breweryId = readStoredId();
  if (!breweryId) {
    return { breweryId: '', ticket: takeTicket };
  }
  removeStoredId();
  takenBreweryId = breweryId;
  takeIsOpen = true;
  takeTicket += 1;
  return { breweryId, ticket: takeTicket };
}

/**
 * Ends the open take. A stale ticket from an earlier effect is ignored.
 * A current numeric ticket retries removal of the stored id before the
 * in-memory take is closed. Calling with no ticket clears any open take.
 * @param {number} [ticket]
 */
export function finishClaimBreweryHandoff(ticket) {
  if (typeof ticket === 'number' && ticket !== takeTicket) {
    return;
  }
  if (typeof ticket === 'number') {
    removeStoredId();
  }
  takeIsOpen = false;
  takenBreweryId = '';
  if (typeof ticket !== 'number') {
    removeStoredId();
    takeTicket += 1;
  }
}
